import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@env';
import { IHotelIntro } from '@core/models/modals';
import { ModalHotelIntroComponent } from '@modals/hotel-intro/hotel-intro.component';
import { dialogConfig } from '@modals/dialog.configure';
import { MbDialog, MbButton, MbIcon, MbIconText } from '@am/moebius';

@Component({
    selector: 'view-map-mobile',
    templateUrl: './view-map-mobile.component.html',
    styleUrls: ['./view-map-mobile.component.scss'],
    standalone: true,
    imports: [
        MbButton,
        MbIcon,
        MbIconText,
    ],
})
export class ViewMapMobileComponent implements OnInit {
  @Output()
  clickMap: EventEmitter<void> = new EventEmitter<void>();
  @Input()
  hotelStatic: any;

  public icon: string;
  public env: any = environment.environment;

  constructor(private dialog: MbDialog) {}

  ngOnInit() {
    this.icon = `/hotels/dist/es-AR/browser/assets/images/hotel-with-bell-pin.svg`;
  }

  public openModalMap() {
    if (!this.dialog.isAnyDialogOpen) {
      const dialogData: IHotelIntro = {
        name: this.hotelStatic.name,
        address: this.hotelStatic.address,
        city: this.hotelStatic.city,
        hotel_position: this.hotelStatic.hotel_position,
        stars: this.hotelStatic.stars,
      };
      this.dialog.open(ModalHotelIntroComponent, {
        ...dialogConfig,
        size: 'lg',
        dialogData: dialogData,
      });
    }
  }
}
